import { Component, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { lastValueFrom, map } from 'rxjs';
import {
  DropdownFilter,
  PageableRequest,
  ShippingOrderControllerService,
  ShippingOrderDetail
} from 'src/app/admin-api';
import { TableColumn } from 'src/app/components/table';

@Component({
  selector: 'app-shipping-orders',
  templateUrl: './shipping-orders.component.html'
})
export class ShippingOrdersComponent {
  public shippingOrderService = inject(ShippingOrderControllerService);

  cols = [
    new TableColumn.Builder()
      .setHeader('Id')
      .setField('shippingOrderId')
      .setRouterLink('/products/shipping-orders/')
      .setRouterLinkFieldName('shippingOrderId')
      .build(),
    new TableColumn(
      'Tipo',
      'shippingOrderTypeName',
      true,
      'text',
      undefined,
      undefined,
      true,
      'equals'
    ),
    new TableColumn(
      'Data',
      'dateCreated',
      true,
      'date',
      undefined,
      undefined,
      true,
      'between'
    ),
    new TableColumn('Produtos', 'items', false, 'formattedInteger'),
    new TableColumn.Builder()
      .setHeader('Status')
      .setField('shippingOrderStatusName')
      .build(),
    new TableColumn.Builder()
      .setHeader('Assinante')
      .setField('personName')
      .setRouterLink('/users/person/')
      .setRouterLinkFieldName('personId')
      .setCondition('contains')
      .build(),
    new TableColumn.Builder()
      .setHeader('Email')
      .setField('personEmail')
      .setRouterLink('/users/person/')
      .setRouterLinkFieldName('personId')
      .build(),
    new TableColumn.Builder()
      .setHeader('Id assinante')
      .setField('personId')
      .setRouterLink('/users/person/')
      .setRouterLinkFieldName('personId')
      .setType('number')
      .build(),
    new TableColumn.Builder()
      .setHeader('Prazo entrega')
      .setField('maxDeliveryDate')
      .setType('date')
      .setCondition('between')
      .build(),
    new TableColumn.Builder()
      .setHeader('Status Millennium')
      .setField('statusMillennium')
      .setCondition('contains')
      .build(),
    new TableColumn.Builder()
      .setHeader('Últ. Atualização Millennium')
      .setField('dateUpdatedMillennium')
      .setCondition('between')
      .setType('date')
      .build(),
    new TableColumn.Builder()
      .setHeader('Data entrega')
      .setField('finalDeliveryDate')
      .setCondition('between')
      .setType('date')
      .build(),
    new TableColumn.Builder()
      .setHeader('Motivo brinde')
      .setField('referenceName')
      .setCondition('contains')
      .build()
  ];
  dropdownFilters = {};

  defaultFilterValues: { [field: string]: any | Array<any> };

  constructor(
    private title: Title,
    private router: Router
  ) {
    this.title.setTitle('Pedidos de produtos da glam');
    this.defaultFilterValues = {
      dateCreated: this.startMovementDates
    };
    this.findShippingOrderTypes().then();
    this.findShippingOrderStatusList().then();
  }

  async findPage(request: PageableRequest, service: unknown) {
    const type = request.filters?.find(
      (f) => f.field === 'shippingOrderTypeName'
    );
    if (type?.value) {
      request.filters?.push({
        condition: 'equals',
        field: 'shippingOrderTypeId',
        fieldType: 'number',
        value: Number(type.value)
      });
    }
    const status = request.filters?.find(
      (f) => f.field === 'shippingOrderStatusName'
    );
    if (status?.value) {
      request.filters?.push({
        condition: 'equals',
        field: 'shippingOrderStatus',
        fieldType: 'number',
        value: Number(status.value)
      });
    }
    const filterEquity = request.filters?.find(
      (f) => f.field === 'brandEquityLabel'
    );
    if (filterEquity?.value) {
      if (Number(filterEquity.value) >= 0)
        request.filters?.push({
          condition: 'equals',
          field: 'brandEquity',
          fieldType: 'number',
          value: filterEquity.value
        });
    }
    return lastValueFrom(
      (service as ShippingOrderControllerService)
        .getShippingOrdersTable(request)
        .pipe(map((data) => data.result))
    );
  }

  goToReference($event: { value: ShippingOrderDetail; field: string }): void {
    let url = '/operations/compositions/id/' + $event.value.compositionId;
    if ($event.value.personId) {
      url = '/users/person/' + $event.value.personId;
    }
    this.router.navigate([url]);
  }

  async findShippingOrderTypes(): Promise<void> {
    this.dropdownFilters['shippingOrderTypeName'] = await lastValueFrom(
      this.shippingOrderService
        .getShippingOrderTypes()
        .pipe(
          map((data) =>
            [{ label: 'Todos', value: null } as DropdownFilter].concat(
              data.result
            )
          )
        )
    );
  }

  async findShippingOrderStatusList(): Promise<void> {
    this.dropdownFilters['shippingOrderStatusName'] = await lastValueFrom(
      this.shippingOrderService.getShippingOrderStatusList().pipe(
        map((data) =>
          [
            {
              label: 'Todos',
              value: null
            } as DropdownFilter
          ].concat(
            data.result.map(
              (status) =>
                ({
                  label: status.shippingOrderStatusName,
                  value: status.shippingOrderStatusId
                }) as DropdownFilter
            )
          )
        )
      )
    );
  }

  get startMovementDates(): Array<Date> {
    const startDate = new Date();
    startDate.setDate(startDate.getDate() - 1);
    return [startDate, new Date()];
  }
}
